module.exports = __webpack_public_path__ + "img/slt-1.prt.01f361c9.jpg";